/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
 
  Badge,
} from "shards-react";

import PageTitle from "../components/common/PageTitle";
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';
import firebase from '../components/firebase';
import { Redirect } from 'react-router';

class BlogPosts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // First list of posts.
      posts: [],
      fetched:false,
      logged_in :false,
    };
    this.get_posts = this.get_posts.bind(this);
    this.delete_post = this.delete_post.bind(this);
    this.change_visibility = this.change_visibility.bind(this);
  }

  

  get_posts = ()=>{

      var that = this;
      that.setState({loading:true,posts:[]});
      firebase.firestore().collection('Posts').orderBy('date','desc').get().then(function(snapshot){

            var list = that.state.posts;

            snapshot.forEach(function(doc){
                var data = doc.data().list;
                data.forEach(function(post){
                    if(post.visibility==="Public")
                        post['theme'] = "primary";
                    else
                        post['theme'] = 'danger';
                    list.push(post);
                })
            })
            console.log(list);
            that.setState({posts:list,loading:false,fetched:true});
      }).catch(function(err){
          toast("Unable to Fetch Post DatA", {containerId: 'A'});
          console.log(err);
      })
  }


  delete_post = (post) =>{


        var that = this;

        var func_ref = firebase.functions().httpsCallable('RemovePost');  
                         
        this.setState({loading:true});      
        var post_data = post;
        post_data['date'] = post.date.toDate().toLocaleDateString();
        console.log(post_data);
        func_ref(post_data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully deleted!");
                        toast('Post Removed Successfully !', {containerId: 'A'});
                        that.get_posts();

                   }
                  else{
                        toast("Unable to remove post", {containerId: 'A'});
                        console.log(data);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to add post", {containerId: 'A'});
        });



  }



  change_visibility = (post) =>{


        var that = this;

        var func_ref = firebase.functions().httpsCallable('ChangeVisibility');  
        var post_data = post;
        post_data['date'] = post.date.toDate().toLocaleDateString();
        console.log(post_data);           
        this.setState({loading:true});      
        func_ref(post).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully deleted!");
                        toast('Visibilty Changed !', {containerId: 'A'});
                        that.get_posts();
                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast("unable to change visibility of post", {containerId: 'A'});
        });



  }


  componentDidMount(){
      this.get_posts();

  }

componentWillMount(){
    var that = this;
    var user = firebase.auth().currentUser;

      if (user) {
            // User is signed in.
            this.setState({logged_in:true});
      } else {
          // No user is signed in.
          this.setState({logged_in:false});
      }

  }


  render() {
    const {
      posts,
      
    } = this.state;

     if(this.state.logged_in){
        //do nothing
    }
    else{
      return <Redirect push to="/login" />;
    }

    return (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Feed" subtitle="News" className="text-sm-left" />
        </Row>

        {/* First Row of Posts */}
        {
        (!this.state.loading  && (this.state.posts.length>0) && this.state.fetched) &&
        <Row>
          {posts.map((post, idx) => (
            <Col lg="3" md="6" sm="12" className="mb-4" key={idx}>
              <Card small className="card-post card-post--1">
                <div
                  className="card-post__image"
                  style={{ backgroundImage: `url(${post.photo_url})` }}
                >
                  <Badge
                    pill
                    className={`card-post__category bg-${post.theme}`}
                  >
                    {post.visibility}
                  </Badge>
                  
                </div>
                <CardBody>
                  <h5 className="card-title">
                    <a href="#" className="text-fiord-blue">
                      {post.title}
                    </a>
                  </h5>
                  <div className="card-text d-inline-block mb-3">
                        {post.description}
                  </div>
                  <br />
                  <span className="text-muted">{new Date(post.date.toDate()).toLocaleDateString()}</span>

                  <hr />
                  <a href="#" style={{color:'red'}} onClick={()=>{this.delete_post(post)}}>Delete</a>
                  <br />
                  {
                    (post.visibility==="Public") &&
                      <a href="#" onClick={()=>{this.change_visibility(post)}}>Make Private</a>  
                  }
                  {
                    (post.visibility==="Private") &&
                      <a href="#" onClick={()=>{this.change_visibility(post)}}>Make Public</a>  
                  }
                  
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
        }

        {
         (!this.state.loading  && !(this.state.posts.length>0)) &&
          <div style={{color:'blue',fontSize: 20}}>
              No Posts Avaiable :(
          </div>
        }
        {
          (this.state.loading) &&
             <Col lg="9" md="12">
                  
                    <div style={{margin: '10%',marginLeft: '50%',marginTop: '20%'}}>
                        <AtomSpinner color="blue" style={{marginLeft: '10%'}}/>  
                        
                    </div>
          

                
              </Col>
        }

      
      </Container>
    );
  }
}

export default BlogPosts;
